import { h, Host } from "@stencil/core";
import state from "../store";
export class GxgTab {
    constructor() {
        this.tab = undefined;
        this.noPadding = false;
        this.flexContainer = false;
        this.flex = false;
        this.overflowAuto = false;
        this.flexDirection = "column";
        this.isSelected = false;
    }
    el;
    render() {
        return (h(Host, { class: {
                "overflow-auto": this.overflowAuto,
                flex: this.flex && this.isSelected,
                open: this.isSelected,
                "not-selected": !this.isSelected,
                "no-padding": this.noPadding,
                large: state.large,
                mercury: state.mercury,
            } }, h("div", { class: {
                container: true,
                "container--flex": this.flexContainer,
                "flex-column": this.flexDirection === "column",
                "flex-row": this.flexDirection === "row",
            }, part: "container" }, h("slot", null))));
    }
    static get is() { return "gxg-tab"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tab.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tab.css"]
        };
    }
    static get properties() {
        return {
            "tab": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The tab id. Should match the \"tab\" value of the correlative \"gxg-tab\""
                },
                "attribute": "tab",
                "reflect": false
            },
            "noPadding": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute removes the tab .container padding"
                },
                "attribute": "no-padding",
                "reflect": false,
                "defaultValue": "false"
            },
            "flexContainer": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the container display flex"
                },
                "attribute": "flex-container",
                "reflect": false,
                "defaultValue": "false"
            },
            "flex": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the display of the tab 'flex' only when is open"
                },
                "attribute": "flex",
                "reflect": false,
                "defaultValue": "false"
            },
            "overflowAuto": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the .container overflow property set to 'auto'"
                },
                "attribute": "overflow-auto",
                "reflect": false,
                "defaultValue": "false"
            },
            "flexDirection": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "TabContainerFlexDirection",
                    "resolved": "\"column\" | \"row\"",
                    "references": {
                        "TabContainerFlexDirection": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tab/tab.tsx",
                            "id": "src/components/tab/tab.tsx::TabContainerFlexDirection"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The container flex-direction, if container is flex."
                },
                "attribute": "flex-direction",
                "reflect": false,
                "defaultValue": "\"column\""
            },
            "isSelected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The selected tab"
                },
                "attribute": "is-selected",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=tab.js.map
